import Loadable from 'react-loadable';
export { CONVERSATION_ASSISTANT_CONTAINER_ID, CONVERSATION_ASSISTANT_CONTAINER_WIDTH, CONVERSATION_ASSISTANT_MINIMUM_HEIGHT, CONVERSATION_ASSISTANT_MINIMUM_WIDTH } from './common/constants/public';
export { ConversationAssistantIcon } from './ui/icon-button/icon';
export const ConversationAssistantIconButton = Loadable({
  loader: () => import( /* webpackChunkName: "@atlaskit-internal_conversation-assistant-icon-button" */'./ui/icon-button').then(module => module.ConversationAssistantIconButton),
  loading: () => null
});